export const SHOPIFY = 'shopify'
export const MAGENTO = 'magento'
export const WOOCOMMERCE = 'woocommerce'
export const VTEX = 'vtex'

export const FINAL_LOADER_TIMEOUT = 36000
export const FINAL_LOADER_DELAY_NOTICE_START = 24000
export const FINAL_LOADER_REDIRECT_NOTICE_START = 31000
export const FINAL_LOADER_FADE_DURATION = 1000
export const PROXY_SCRAPER_STEP_THREE_DELAY = 3000

export const CENTS_PER_UNIT = 100
export const FLOATING_POINT_PRECISION_DIGITS = 6
